import Vuex from 'vuex'
import Vue from 'vue'
import Home from './modules/Home'
import Admin from './modules/Admin'
import Benutzer from './modules/Benutzer'
import Kontakt from './modules/Kontakte'
import Messages from './modules/Messages'
import Fotoalben from './modules/Fotoalben'
import Sigfox from './modules/Sigfox'
import Geraet from './modules/Geraet'
import Geraetetyp from './modules/Geraetetyp'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    Home,
    Admin,
    Benutzer,
    Kontakt,
    Messages,
    Fotoalben,
    Sigfox,
    Geraet,
    Geraetetyp
  }
})